import { OpenIdConfiguration } from '@e2m-customer-portal/shared';
import { suspend } from 'suspend-react';
import { fetchWithRequestId, withRequestId } from '../../utils';

export function useOpenIdConfig(): OpenIdConfiguration & { clientId: string } {
  return suspend(async () => {
    const linksResponse = (await fetchWithRequestId()('/api/v1/openid-links')) as Response & {
      requestId: string;
    };
    if (!linksResponse.ok) {
      throw withRequestId(new Error('Failed to fetch OpenId config URL.'), linksResponse.requestId);
    }

    const links = (await linksResponse.json()) as Record<'configUri' | 'clientId', string>;
    // CORS of KeyCloak does not allow additional header
    const configResponse = await fetch(links.configUri);
    if (!configResponse.ok) {
      throw new Error('Failed to fetch OpenId configuration.');
    }

    const config = (await configResponse.json()) as OpenIdConfiguration & { clientId: string };
    config.clientId = links.clientId;

    return config as OpenIdConfiguration & { clientId: string };
  }, [useOpenIdConfig.name]);
}
